import { locale } from '../locale'
import { role } from '../role'
import { z } from 'zod'

export const avatarConfig = z
    .object({
        glasses: z.enum(['normal']).nullable().optional(),
        glassesProbability: z.string().nullable().optional(),
        eyes: z.enum(['normal', 'confident', 'happy']).nullable().optional(),
        bodyColor: z.string().nullable().optional(),
        body: z.enum(['tShirt', 'golf']).nullable().optional(),
        head: z.enum(['normal', 'wide', 'thin']).nullable().optional(),
        hairColor: z.string().nullable().optional(),
        hair: z
            .enum(['balndess', 'slaughter', 'ponyTail', 'long', 'curly', 'stylish', 'elvis', 'classic02', 'classic01'])
            .nullable()
            .optional(),
        mouth: z.enum(['default', 'missingTooth']).nullable().optional(),
        mustache: z.enum(['none', 'pencilThinBeard', 'pencilThin', 'horshoe', 'freddy']).nullable().optional(),
        mustacheProbability: z.string().nullable().optional(),
        blushesProbability: z.string().nullable().optional(),
        skinColor: z.string().nullable().optional(),
    })
    .nullable()
    .optional()

export const updateInput = z.object({
    name: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    locale: locale.nullable().optional(),
    role: role.nullable().optional(),
    avatarConfig: avatarConfig,
})

export type UpdateInput = z.infer<typeof updateInput>
export type AvatarConfig = z.infer<typeof avatarConfig>
